export const PRODUCTS: ReadonlyArray<{ name: string; price: string }> = [
  { name: 'Barongo 26/1 DR', price: '6,50' },
  { name: 'Barongo 30/1 Cali', price: '6,99' },
  { name: 'Barongo 28/1 Cali', price: '6,99' },
  { name: 'Barongo 26/1 Kali', price: '6,99' },
  { name: 'Barongo 24/1 Upside Down Cake', price: '8,99' },
  { name: 'Barongo 24/1 Banjo', price: '7,99' },
  { name: 'Barongo 26/1 SSS (Sunset Strudel)', price: '9,90' },
  { name: 'Barongo 27/1 MAC3', price: '6,99' },
  { name: 'Barongo 28/1 SR (Skiltz Runtz)', price: '10,44' },
  { name: 'Buuo 24/1 JGB (Juggernaut Gas Breath)', price: '6,99' },
  { name: 'Buuo 22/1 CDLC (Cold Dank Jelly Breath)', price: '5,99' },
  { name: 'enua 22/1 SAM CA (Super Alien Mints)', price: '5,95' },
  { name: 'enua 22/1 BCP CA (Black Cherry Punch)', price: '6,95' },
  { name: 'enua 25/1 SC CA (Strawberry Cake)', price: '7,89' },
  { name: 'Haua 25/1 CA ALM (Alien Mints)', price: '6,49' },
  { name: 'Aurora 22/1 (Delahaze)', price: '7,99' },
  { name: 'Remexian 27/1 CIV PKU (Poison Kush)', price: '7,34' },
];
